import { render, staticRenderFns } from "./StockCompartido.vue?vue&type=template&id=35fdc8ae"
import script from "./StockCompartido.vue?vue&type=script&setup=true&lang=js"
export * from "./StockCompartido.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports